/**
 * Created by Carsten Bühler
 * User: c.buehler on 14.10.2016
 * Copyright: xdot GmbH 2015
 */


/**
 * Highlighted Polygon Style
 */

export function getPropertiesFromLocalConfig(localConfig, defaultValue = {}) {
    return localConfig && localConfig.properties || defaultValue;
}



// WEBPACK FOOTER //
// ./js/utils/local-config-util.js